import type { AxiosInstance } from 'axios'
import { request } from '../client'
import type {
  TVMAssignment,
  TVMAssignmentList,
  TVMAssignmentRequest,
} from '../types/staff'

export interface VMAssignmentApi {
  list: (params?: { unassigned?: boolean; customer_id?: number; organization_id?: number }) => Promise<TVMAssignmentList>
  get: (vmId: number) => Promise<TVMAssignment>
  assign: (vmId: number, req: TVMAssignmentRequest) => Promise<TVMAssignment>
  unassign: (vmId: number) => Promise<void>
}

export function createVMAssignmentApi(api: AxiosInstance): VMAssignmentApi {
  const base = '/staff/vms'
  return {
    list: (params) =>
      request<TVMAssignmentList>(api, { method: 'GET', url: base, params }),
    get: (vmId) =>
      request<TVMAssignment>(api, { method: 'GET', url: `${base}/${vmId}` }),
    assign: (vmId, req) =>
      request<TVMAssignment>(api, { method: 'PUT', url: `${base}/${vmId}/assignment`, data: req }),
    unassign: (vmId) =>
      request<void>(api, { method: 'DELETE', url: `${base}/${vmId}/assignment` }),
  }
}
